import axios from "axios";

const instance = axios.create({
  timeout: 5000,
});
//http request 拦截器
instance.interceptors.request.use(
  (config) => {
    if (config.method == "post" && config.data) {
      config.headers = {
        "Content-Type": "multipart/form-data",
      };
      const formData = new FormData();
      Object.keys(config.data).forEach((key) => {
        formData.append(key, config.data[key]);
      });
      config.data = formData;
    } else if (config.method == "patch" && config.data) {
      config.headers = {
        "Content-Type": "application/json;charset=UTF-8",
      };
      config.method = "post";
    }
    /**统一添加头 */
    config.headers = {
      "X-Requested-With": "XMLHttpRequest",
      // "Cookie":""
    };
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);
// Add a response interceptor
instance.interceptors.response.use(
  function(response) {
    // Any status code that lie within the range of 2xx cause this function to trigger
    // Do something with response data
    return response;
  },
  function(error) {
    // Any status codes that falls outside the range of 2xx cause this function to trigger
    // Do something with response error
    return Promise.reject(error);
  }
);
export const get = (url, params) => instance.get(url, { params });
export const post = (url, params) => instance.post(url, params);
